
import React ,{useEffect , useState} from 'react'
import {Link} from "react-router-dom"

// import swal from 'sweetalert';



import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";






import cat1 from '../assets/images/cat (1).jpg'
import cat2 from '../assets/images/cat (2).jpg'
import cat3 from '../assets/images/cat (3).jpg'
import cat4 from '../assets/images/cat (4).jpg'
import cat5 from '../assets/images/cat (5).jpg'
import cat6 from '../assets/images/cat (6).jpg'
import cat7 from '../assets/images/cat (7).jpg'











const Cate = (props) =>{
    const responsive = {
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 9,
          slidesToSlide: 4 // optional, default to 1.
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 5,
          slidesToSlide: 3 // optional, default to 1.
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 3,
          slidesToSlide: 3 // optional, default to 1.
        }
      };
    
      const [MainCatogories , setMainCatogories] = useState([])



      useEffect(() =>{


        fetch("https://malook-pk-front-back.vercel.app/MainCatogories",{
            method: "GET",
             headers :  {
             "Content-Type" : "application/json" , 
         } ,
        })
        .then(res2=>res2.json())
        .then(res3=>{
            console.log(res3);
            // setMainCatogories(res3)
            

            let dat = []
            res3.map((res55,c)=>{
                dat.push(res55)
            })
            // console.log(SubClassCategories,asse)
            console.log(dat)
            let data = dat.sort((a, b) => {
                return a.sort - b.sort;
            });
            setMainCatogories(data)
            
        })

},[])


// const changeFruit = (goto) => {
//   // setCurrentFruit(newFruit)
//   props.history.push(goto)
// }



// function redirect(goto){
//   if (goto != '') {
//       props.history.push(goto)
//       window.location = goto;
//   }
// }
// document.getElementById('cat1').onchange = function(){
//   var goto = this.value;
//   redirect(goto);
  
// };
return (

<div style={{display:"flex",background :"#F9F9F9",margin:"auto",flexFlow: "wrap",justifyContent: "center"}}>












{  
MainCatogories.map((res,i)=>{
  
      

        if(i+1 == 1 || i+1 == 4 || i+1 == 5 || i+1 == 8 || i+1 ==9){
          if(res.MainCategories ===  "Bridals"){
            return (
                            
            <div className="col-md-8 col-lg-8 col-sm-12 category position-relative" style={{margin:"0px 0px",border:"1px solid white", background:"white",borderRadius:"10px",padding  :"10px 7px"}}>
                                                        <div>
                                                              <Link style={{  display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",  overflow: "hidden"              }} to={"/categories/"+res.MainCategories+"/all-products"} >
                                                            <img src={cat6} className="sdfsfkkj6" width={"100%"} height={160} style={{width :"100%",height:"400px",objectFit:"cover" ,margin: "auto"}} alt={res.MainCategories}/>
                                                           <span className="category-title font-weight-normal sdfsfkkj11" ><b className='sdfsfkkj31' style={{ borderRadius : "5px",color : "black",maxWidth:"100px",height:"70px",fontSize: "1em",lineHeight: 1.1,
                                        fontWeight: "400"}}>{res.MainCategories}        </b> </span>
                                                          </Link>
                                                        </div>
                                                        
                                                      </div>


           
              )
          }
          if(res.MainCategories ===  "Saree"){
            return (
                            
            <div className="col-md-8 col-lg-8 col-sm-12 category position-relative" style={{margin:"0px 0px",border:"1px solid white", background:"white",borderRadius:"10px",padding  :"10px 7px"}}>
                                                        <div>
                                                              <Link style={{  display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",  overflow: "hidden"              }} to={"/categories/"+res.MainCategories+"/all-products"} >
                                                            <img src={cat3} className="sdfsfkkj6" width={"100%"} height={160} style={{width :"100%",height:"400px",objectFit:"cover" ,margin: "auto"}} alt={res.MainCategories}/>
                                                           <span className="category-title font-weight-normal sdfsfkkj11" ><b className='sdfsfkkj31' style={{ borderRadius : "5px",color : "black",maxWidth:"100px",height:"70px",fontSize: "1em",lineHeight: 1.1,
                                        fontWeight: "400"}}>{res.MainCategories}        </b> </span>
                                                          </Link>
                                                        </div>
                                                        
                                                      </div>


           
              )
          }
          if(res.MainCategories ===  "Lawn"){
            return (
                            
            <div className="col-md-8 col-lg-8 col-sm-12 category position-relative" style={{margin:"0px 0px",border:"1px solid white", background:"white",borderRadius:"10px",padding  :"10px 7px"}}>
                                                        <div>
                                                              <Link style={{  display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",  overflow: "hidden"              }} to={"/categories/"+res.MainCategories+"/all-products"} >
                                                            <img src={cat2} className="sdfsfkkj6" width={"100%"} height={160} style={{width :"100%",height:"400px",objectFit:"cover" ,margin: "auto"}} alt={res.MainCategories}/>
                                                           <span className="category-title font-weight-normal sdfsfkkj11" ><b className='sdfsfkkj31' style={{ borderRadius : "5px",color : "black",maxWidth:"100px",height:"70px",fontSize: "1em",lineHeight: 1.1,
                                        fontWeight: "400"}}>{res.MainCategories}        </b> </span>
                                                          </Link>
                                                        </div>
                                                        
                                                      </div>


           
              )
          }
          if(res.MainCategories ===  "Shawls"){
            return (
                            
            <div className="col-md-8 col-lg-8 col-sm-12 category position-relative" style={{margin:"0px 0px",border:"1px solid white", background:"white",borderRadius:"10px",padding  :"10px 7px"}}>
                                                        <div>
                                                              <Link style={{  display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",  overflow: "hidden"              }} to={"/categories/"+res.MainCategories+"/all-products"} >
                                                            <img src={cat5} className="sdfsfkkj6" width={"100%"} height={160} style={{width :"100%",height:"400px",objectFit:"cover" ,margin: "auto"}} alt={res.MainCategories}/>
                                                           <span className="category-title font-weight-normal sdfsfkkj11" ><b className='sdfsfkkj31' style={{ borderRadius : "5px",color : "black",maxWidth:"100px",height:"70px",fontSize: "1em",lineHeight: 1.1,
                                        fontWeight: "400"}}>{res.MainCategories}        </b> </span>
                                                          </Link>
                                                        </div>
                                                        
                                                      </div>


           
              )
          }
          if(res.MainCategories ===  "Luxury Pret"){
            return (
                            
            <div className="col-md-8 col-lg-8 col-sm-12 category position-relative" style={{margin:"0px 0px",border:"1px solid white", background:"white",borderRadius:"10px",padding  :"10px 7px"}}>
                                                        <div>
                                                              <Link style={{  display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",  overflow: "hidden"              }} to={"/categories/"+res.MainCategories+"/all-products"} >
                                                            <img src={cat4} className="sdfsfkkj6" width={"100%"} height={160} style={{width :"100%",height:"400px",objectFit:"cover" ,margin: "auto"}} alt={res.MainCategories}/>
                                                           <span className="category-title font-weight-normal sdfsfkkj11" ><b className='sdfsfkkj31' style={{ borderRadius : "5px",color : "black",maxWidth:"100px",height:"70px",fontSize: "1em",lineHeight: 1.1,
                                        fontWeight: "400"}}>{res.MainCategories}        </b> </span>
                                                          </Link>
                                                        </div>
                                                        
                                                      </div>


           
              )
          }
          if(res.MainCategories ===  "Formals"){
            return (
                            
            <div className="col-md-8 col-lg-8 col-sm-12 category position-relative" style={{margin:"0px 0px",border:"1px solid white", background:"white",borderRadius:"10px",padding  :"10px 7px"}}>
                                                        <div>
                                                              <Link style={{  display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",  overflow: "hidden"              }} to={"/categories/"+res.MainCategories+"/all-products"} >
                                                            <img src={cat1} className="sdfsfkkj6" width={"100%"} height={160} style={{width :"100%",height:"400px",objectFit:"cover" ,margin: "auto"}} alt={res.MainCategories}/>
                                                           <span className="category-title font-weight-normal sdfsfkkj11" ><b className='sdfsfkkj31' style={{ borderRadius : "5px",color : "black",maxWidth:"100px",height:"70px",fontSize: "1em",lineHeight: 1.1,
                                        fontWeight: "400"}}>{res.MainCategories}        </b> </span>
                                                          </Link>
                                                        </div>
                                                        
                                                      </div>


           
              )
          }
          if(res.MainCategories ===  "Western formals"){
            return (
                            
            <div className="col-md-8 col-lg-8 col-sm-12 category position-relative" style={{margin:"0px 0px",border:"1px solid white", background:"white",borderRadius:"10px",padding  :"10px 7px"}}>
                                                        <div>
                                                              <Link style={{  display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",  overflow: "hidden"              }} to={"/categories/"+res.MainCategories+"/all-products"} >
                                                            <img src={cat7} className="sdfsfkkj6" width={"100%"} height={160} style={{width :"100%",height:"400px",objectFit:"cover" ,margin: "auto"}} alt={res.MainCategories}/>
                                                           <span className="category-title font-weight-normal sdfsfkkj11" ><b className='sdfsfkkj31' style={{ borderRadius : "5px",color : "black",maxWidth:"100px",height:"70px",fontSize: "1em",lineHeight: 1.1,
                                        fontWeight: "400"}}>{res.MainCategories}        </b> </span>
                                                          </Link>
                                                        </div>
                                                        
                                                      </div>


           
              )
          }
          
        }
        else{
          if(res.MainCategories ===  "Bridals"){
            return (
                            
            <div className="col-md-4 col-lg-4 col-sm-12 category position-relative" style={{margin:"0px 0px",border:"1px solid white", background:"white",borderRadius:"10px",padding  :"10px 7px"}}>
                                                        <div>
                                                              <Link style={{  display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",  overflow: "hidden"              }} to={"/categories/"+res.MainCategories+"/all-products"} >
                                                            <img src={cat6} className="sdfsfkkj6" width={"100%"} height={160} style={{width :"100%",height:"400px",objectFit:"cover" ,margin: "auto"}} alt={res.MainCategories}/>
                                                           <span className="category-title font-weight-normal sdfsfkkj11" ><b className='sdfsfkkj31' style={{ borderRadius : "5px",color : "black",maxWidth:"100px",height:"70px",fontSize: "1em",lineHeight: 1.1,
                                        fontWeight: "400"}}>{res.MainCategories}        </b> </span>
                                                          </Link>
                                                        </div>
                                                        
                                                      </div>


           
              )
          }
          if(res.MainCategories ===  "Saree"){
            return (
                            
            <div className="col-md-4 col-lg-4 col-sm-12 category position-relative" style={{margin:"0px 0px",border:"1px solid white", background:"white",borderRadius:"10px",padding  :"10px 7px"}}>
                                                        <div>
                                                              <Link style={{  display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",  overflow: "hidden"              }} to={"/categories/"+res.MainCategories+"/all-products"} >
                                                            <img src={cat3} className="sdfsfkkj6" width={"100%"} height={160} style={{width :"100%",height:"400px",objectFit:"cover" ,margin: "auto"}} alt={res.MainCategories}/>
                                                           <span className="category-title font-weight-normal sdfsfkkj11" ><b className='sdfsfkkj31' style={{ borderRadius : "5px",color : "black",maxWidth:"100px",height:"70px",fontSize: "1em",lineHeight: 1.1,
                                        fontWeight: "400"}}>{res.MainCategories}        </b> </span>
                                                          </Link>
                                                        </div>
                                                        
                                                      </div>


           
              )
          }
          if(res.MainCategories ===  "Lawn"){
            return (
                            
            <div className="col-md-4 col-lg-4 col-sm-12 category position-relative" style={{margin:"0px 0px",border:"1px solid white", background:"white",borderRadius:"10px",padding  :"10px 7px"}}>
                                                        <div>
                                                              <Link style={{  display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",  overflow: "hidden"              }} to={"/categories/"+res.MainCategories+"/all-products"} >
                                                            <img src={cat2} className="sdfsfkkj6" width={"100%"} height={160} style={{width :"100%",height:"400px",objectFit:"cover" ,margin: "auto"}} alt={res.MainCategories}/>
                                                           <span className="category-title font-weight-normal sdfsfkkj11" ><b className='sdfsfkkj31' style={{ borderRadius : "5px",color : "black",maxWidth:"100px",height:"70px",fontSize: "1em",lineHeight: 1.1,
                                        fontWeight: "400"}}>{res.MainCategories}        </b> </span>
                                                          </Link>
                                                        </div>
                                                        
                                                      </div>


           
              )
          }
          if(res.MainCategories ===  "Shawls"){
            return (
                            
            <div className="col-md-4 col-lg-4 col-sm-12 category position-relative" style={{margin:"0px 0px",border:"1px solid white", background:"white",borderRadius:"10px",padding  :"10px 7px"}}>
                                                        <div>
                                                              <Link style={{  display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",  overflow: "hidden"              }} to={"/categories/"+res.MainCategories+"/all-products"} >
                                                            <img src={cat5} className="sdfsfkkj6" width={"100%"} height={160} style={{width :"100%",height:"400px",objectFit:"cover" ,margin: "auto"}} alt={res.MainCategories}/>
                                                           <span className="category-title font-weight-normal sdfsfkkj11" ><b className='sdfsfkkj31' style={{ borderRadius : "5px",color : "black",maxWidth:"100px",height:"70px",fontSize: "1em",lineHeight: 1.1,
                                        fontWeight: "400"}}>{res.MainCategories}        </b> </span>
                                                          </Link>
                                                        </div>
                                                        
                                                      </div>


           
              )
          }
          if(res.MainCategories ===  "Luxury Pret"){
            return (
                            
            <div className="col-md-4 col-lg-4 col-sm-12 category position-relative" style={{margin:"0px 0px",border:"1px solid white", background:"white",borderRadius:"10px",padding  :"10px 7px"}}>
                                                        <div>
                                                              <Link style={{  display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",  overflow: "hidden"              }} to={"/categories/"+res.MainCategories+"/all-products"} >
                                                            <img src={cat4} className="sdfsfkkj6" width={"100%"} height={160} style={{width :"100%",height:"400px",objectFit:"cover" ,margin: "auto"}} alt={res.MainCategories}/>
                                                           <span className="category-title font-weight-normal sdfsfkkj11" ><b className='sdfsfkkj31' style={{ borderRadius : "5px",color : "black",maxWidth:"100px",height:"70px",fontSize: "1em",lineHeight: 1.1,
                                        fontWeight: "400"}}>{res.MainCategories}        </b> </span>
                                                          </Link>
                                                        </div>
                                                        
                                                      </div>


           
              )
          }
          if(res.MainCategories ===  "Formals"){
            return (
                            
            <div className="col-md-4 col-lg-4 col-sm-12 category position-relative" style={{margin:"0px 0px",border:"1px solid white", background:"white",borderRadius:"10px",padding  :"10px 7px"}}>
                                                        <div>
                                                              <Link style={{  display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",  overflow: "hidden"              }} to={"/categories/"+res.MainCategories+"/all-products"} >
                                                            <img src={cat1} className="sdfsfkkj6" width={"100%"} height={160} style={{width :"100%",height:"400px",objectFit:"cover" ,margin: "auto"}} alt={res.MainCategories}/>
                                                           <span className="category-title font-weight-normal sdfsfkkj11" ><b className='sdfsfkkj31' style={{ borderRadius : "5px",color : "black",maxWidth:"100px",height:"70px",fontSize: "1em",lineHeight: 1.1,
                                        fontWeight: "400"}}>{res.MainCategories}        </b> </span>
                                                          </Link>
                                                        </div>
                                                        
                                                      </div>


           
              )
          }
          if(res.MainCategories ===  "Western formals"){
            return (
                            
            <div className="col-md-4 col-lg-4 col-sm-12 category position-relative" style={{margin:"0px 0px",border:"1px solid white", background:"white",borderRadius:"10px",padding  :"10px 7px"}}>
                                                        <div>
                                                              <Link style={{  display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",  overflow: "hidden"              }} to={"/categories/"+res.MainCategories+"/all-products"} >
                                                            <img src={cat7} className="sdfsfkkj6" width={"100%"} height={160} style={{width :"100%",height:"400px",objectFit:"cover" ,margin: "auto"}} alt={res.MainCategories}/>
                                                           <span className="category-title font-weight-normal sdfsfkkj11" ><b className='sdfsfkkj31' style={{ borderRadius : "5px",color : "black",maxWidth:"100px",height:"70px",fontSize: "1em",lineHeight: 1.1,
                                        fontWeight: "400"}}>{res.MainCategories}        </b> </span>
                                                          </Link>
                                                        </div>
                                                        
                                                      </div>


           
              )
          }
          
                //  return (
                            
                //             <div className="col-md-4 col-lg-4 col-sm-12 category position-relative" style={{margin:"0px 0px",border:"1px solid white", background:"white",borderRadius:"10px",padding  :"10px 7px"}}>
                //                                                         <div>
                //                                                               <Link style={{  display: "flex",
                //                 justifyContent: "center",
                //                 alignItems: "flex-end", overflow: "hidden"   }} to={"/categories/"+res.MainCategories+"/all-products"} >
                //                                                             <img src={res.photo} className="sdfsfkkj6" width={"100%"} height={160} style={{width :"100%",height:"400px",objectFit:"cover" ,margin: "auto"}} alt={res.MainCategories}/>
                //                                                            <span className="category-title font-weight-normal sdfsfkkj11" ><b className='sdfsfkkj31' style={{ borderRadius : "5px",color : "black",maxWidth:"100px",height:"70px",fontSize: "1em",lineHeight: 1.1,
                //                                         fontWeight: "400"}}>{res.MainCategories}        </b> </span>
                //                                                           </Link>
                //                                                         </div>
                                                                        
                //                                                       </div>


                           
                //               )
        }
                     

                          // }
                          })
               }
</div>
            
                        
          

    )
}

export default Cate